document.addEventListener('DOMContentLoaded', function () {
  const counters = document.querySelectorAll('.counter-number');
  counters.forEach(counter => {
    const raw = counter.getAttribute('data-target');
    const suffix = raw.replace(/[0-9]/g, '');
    const target = parseInt(raw.replace(/[^0-9]/g, ''));
    if (isNaN(target)) return;
    const duration = 2000;
    const step = target / (duration / 16);
    let current = 0;
    const timer = setInterval(() => {
      current += step;
      if (current >= target) {
        counter.textContent = target.toLocaleString() + suffix;
        clearInterval(timer);
      } else {
        counter.textContent = Math.floor(current).toLocaleString() + suffix;
      }
    }, 16);
  });
});
